import { OntologyFieldType, useOntology } from 'features/dynamicOntology'
import { useMemo } from 'react'

interface UseFieldTypeProps {
  isEditingCustomProperty: boolean
  customPropertyType: OntologyFieldType
  selectedField: string
}

export const useFieldType = ({
  isEditingCustomProperty,
  customPropertyType,
  selectedField,
}: UseFieldTypeProps): OntologyFieldType => {
  const { fields } = useOntology()

  return useMemo((): OntologyFieldType => {
    if (isEditingCustomProperty) return customPropertyType
    if (!selectedField) return 'text'
    return (fields[selectedField]?.type as OntologyFieldType) || 'text'
  }, [isEditingCustomProperty, customPropertyType, selectedField, fields])
}
